import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { formatNumber } from '../../../../../Utils';
import { parseMoney } from './pmt.js';

function formatMoney(n) {
    if (!Number.isFinite(n) || n <= 0) return '—';
    return `$${formatNumber(n.toFixed(2))}`;
}

function PlazoComparisonTable({ state, isCotizador3 = false }) {
    const rows = useMemo(() => {
        const pdfPlazo = (state?.pdfPlazo || []).filter(p => !p.ignore);
        return pdfPlazo
            .map(p => {
                const base = parseMoney(
                    p?.section3?.['Pago Mensual Base (s/IVA)']?.[1] ||
                    p?.section3?.['Pago Mensual Base (s/IVA)']?.[0] ||
                    p?.section3?.['Capital']?.[1] ||
                    p?.section3?.['Capital']?.[0]
                );
                const total = parseMoney(
                    p?.section3?.['Pago Mensual Total (incl IVA)']?.[1] ||
                    p?.section3?.['Total Pago Mensual (incl IVA)']?.[1] ||
                    p?.section3?.['Pago Mensual Total (incl IVA)']?.[0] ||
                    p?.section3?.['Total Pago Mensual (incl IVA)']?.[0]
                );
                return { plazo: p.plazo, base, total, isCurrent: !!p.selected };
            })
            .sort((a, b) => a.plazo - b.plazo);
    }, [state]);

    if (!rows.length) return null;

    return (
        <div className="PlazoComparison">
            <div className="MatrixHeader">
                <div className="MatrixTitle">
                    <span className="Dot" />
                    <h3>Comparativa por plazo</h3>
                    <span className="Subtitle">{isCotizador3 ? 'valores estimados, pueden cambiar' : 'arrendamiento financiero'}</span>
                </div>
            </div>

            <div className="MatrixScroll">
                <table className="MatrixTable">
                    <thead>
                        <tr>
                            <th className="col-head">Plazo</th>
                            <th className="col-head money">Pago base (s/IVA)</th>
                            <th className="col-head money">Pago total (c/IVA)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, idx) => (
                            <motion.tr
                                key={row.plazo}
                                className={row.isCurrent ? 'current-row' : ''}
                                initial={{ opacity: 0, y: 6 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: idx * 0.05, duration: 0.3 }}
                            >
                                <td className="pct-cell">
                                    <span className="pct-badge">{row.plazo} meses</span>
                                </td>
                                <td className="money">{formatMoney(row.base)}</td>
                                <td className="money plazo-cell">
                                    {formatMoney(row.total)}
                                </td>
                            </motion.tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export { PlazoComparisonTable };
